<template>
  <custom-actions show-back>
    <el-form label-width="120px" v-loading="loading">
      <el-form-item label="生产编号">{{ detail.productionCode }}</el-form-item>
      <!-- 详情与列表统一展示来源生产记录的当班日期。 -->
      <el-form-item label="当班日期">{{ detail.shiftDate }}</el-form-item>
      <el-form-item label="产品名称">{{ detail.specName }}</el-form-item>
      <el-form-item label="产量">{{ detail.quantity }}</el-form-item>
      <el-form-item label="绩效系数">{{ detail.performanceCoefficient }}</el-form-item>
      <el-form-item label="生产绩效">{{ detail.performancePrice }}</el-form-item>
      <el-form-item label="创建时间">{{ detail.ctime }}</el-form-item>
    </el-form>
  </custom-actions>
</template>
<script>
export default {
  name: 'ProductionPerformanceDetail',
  data() { return { detail: {}, loading: false } },
  created() { this.loadData() },
  methods: {
    // 详情仅查询生产绩效专用接口，储运绩效ID不能用于生产详情。
    async loadData() {
      this.loading = true
      try { this.detail = await this.$axios.get(this.$apis.productionPerformance.selectById, { id: this.$route.query.id }) } finally { this.loading = false }
    }
  }
}
</script>
